module.exports = __webpack_public_path__ + "media/images/aloe/icons/checkout/world-63b7b3d7df0524f2f726d84b4ab61975.svg";